import React from "react";
import color from "../../utils/color";

export default ({ margin }) => {
  return <hr color={color.gray} style={{ margin }} size="1" />;
};
